import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
/** validation de formulaire */
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import usePostAxiosData from 'hooks/usePostAxiosData';
import toast from 'react-hot-toast';

import InputField from 'components/fields/InputField';
import { Alert, AlertIcon, AlertTitle, Badge, Button, Tooltip } from '@chakra-ui/react';
import Error from 'components/message/Error';
import FormSkeleton from 'components/FormSkeleton';
import useDataFetching from 'hooks/useDataFetching';
import useAppQuery from 'hooks/useAppQuery';
import { config } from 'variables/config';
import { format } from 'prettier';
import { useAuthUser } from 'react-auth-kit';
import dayjs from 'dayjs';
import { BsBan, BsPencilSquare } from 'react-icons/bs';
import { checkIsValidPermit } from 'utils';
import { getExpiredPermitDate } from 'utils';
import 'dayjs/locale/fr'; // load on demand
import { checkIsValidPermitDate } from 'utils';
import {
  AppBar,
  Chip,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Slide,
  Toolbar,
  Typography,
  capitalize,
} from '@mui/material';
import { CloseModalButton } from 'components/Utils';
import MuiAsyncAutocomplete from 'components/MuiAsyncAutocomplete';
import MuiCollapse from 'components/MuiCollapse';
import MButton from 'components/Mbutton';
import { formatDate } from 'utils';
import { checkIsValidContractDate } from 'utils';
import { checkIsValidContrat } from 'utils';
import MuiAUtocomplete from 'components/MuiAutocomplete';
import MuiSelect from 'components/MuiSelect';
import MuiDatePicker from 'components/MuiDatePicker';
import { formatDateTime } from 'utils';
import { EWORK_DEMANDE_STATUS } from 'Constaints';
import EworkDemandStatusAlert from 'components/EworkDemandStatusAlert';
import GeoRestrictionAlert from 'components/GeoRestrictionAlert';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const AddContract = ({
  open,
  handleClose,
  handleCloseOnly,
  get,
  selectedContract,
  selectedEmployer,
  contract,
  fixedEnterprise,
  setContract,
}) => {
  if (!open) return null;
  const { t } = useTranslation('add_contract');

  // Identify if we're in update mode based on selectedContract
  const isUpdateMode = Boolean(selectedContract?.id);

  /** Form validation config */
  var relativeTime = require('dayjs/plugin/relativeTime');
  dayjs.extend(relativeTime);
  const [occupationName, setOccupationName] = useState('');
  // console.log("🚀 ~ AddContract ~ occupationName:", occupationName)

  const schema = yup.object().shape({
    // contratNumber: yup.string(),
    permitNumber: yup.string(),
    salary: yup.string().required(t('error_required_field')),
    indTransport: yup.string().default('0'),
    indLogement: yup.string().default('0'),
    indResponsabilite: yup.string().default('0'),
    indRepresentation: yup.string().default('0'),
    primeExploitation: yup.string().default('0'),
    sursalaire: yup.string().default('0'),
    primeSalissure: yup.string().default('0'),
    indCaisse: yup.string().default('0'),
    bonus: yup.string().default('0'),
    primePanier: yup.string().default('0'),
    billetAvion: yup.string().default('0'),
    autresPrimes: yup.string().default('0'),
  });
  const auth = useAuthUser();
  const [contractDuration, setContractDuration] = useState(null);
  const [hasPermit, setHasPermit] = useState('Oui');
  const [isGeoRestrictionError, setIsGeoRestrictionError] = useState(false);
  const [loadingCt, errorCt, contractData, fetchContractData] = useDataFetching(
    selectedContract?.id ? `${config.app.api_url}/contracts/${selectedContract?.id}` : null,
    false
  );
  const { data: modifications } = useAppQuery(
    selectedContract?.id
      ? `${config.app.api_url}/contracts/${selectedContract?.id}/modifications`
      : null
  );
  const [date, setDate] = useState(null);
  const [occupation, setOccupation] = useState(null);
  // const [category, setCategory] = useState(null);
  const [, setEnterprise] = useState(null);
  const [canEdit, setCanEdit] = useState(false);

  // Fetch contract data when selectedContract changes
  useEffect(() => {
    if (selectedContract?.id && open) {
      fetchContractData();
    }
  }, [selectedContract?.id, open]);

  // Handle error when fetching contract details in update mode
  useEffect(() => {
    if (errorCt && isUpdateMode) {
      if (errorCt?.data?.isGeoRestrictionFlagged) {
        setIsGeoRestrictionError(true);
        toast.error(
          t('alerts.geographicRestrictionError') ||
            'Geographic restriction error. You do not have access to this contract.',
          {
            duration: 5000,
          }
        );
      } else {
        setIsGeoRestrictionError(false);

        toast.error(
          t('alerts.failedToLoadContractDetails') ||
            'Failed to load contract details. Please try again.',
          {
            duration: 5000,
          }
        );
      }
    }
  }, [errorCt, isUpdateMode]);

  const handleReset = () => {
    reset();
    // setresidencePermitExpDate(null)
    setDate(null);
    setOccupation(null);
    setEnterprise(null);
    setContractDuration(null);
    // setCanEdit(false)
    setHasPermit('Non');
  };

  const durations = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
  ];

  // fetch categories
  // const [loadingC, errorC, categories, fetchDataC] = useDataFetching(
  //   `${config.app.api_url}/categories`
  // );

  // fetch enterprises
  // const [loadingE, errorE, enterprises, fetchDataE] = useDataFetching(
  //   `${config.app.api_url}/enterprises/labels`
  // );

  // fetch occupations
  const { data: occupations } = useAppQuery(`${config.app.api_url}/occupations/all`);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(schema),
  });
  console.log('🚀 ~ AddEmployer ~ errors:', errors);

  const onSubmitHandler = (data) => {
    handleSave(data);
    // reset();
  };

  /** post create employer */
  const [loading, postAxiosData, errorMassage, successMessage] = usePostAxiosData(
    `employers/${selectedEmployer?.id}/add-contract`,
    'POST'
  );

  /** post create employer */
  const [, createOccupation, , successMessageO] = usePostAxiosData(`occupations`, 'POST');

  // console.log("🚀 ~ AddContract ~ createdOccupation:", createdOccupation)

  const handleSave = async (formData) => {
    const data = {
      ...formData,
      id: selectedContract?.id || null,
      creatorId: selectedContract?.id ? null : auth()?.user?.id,
      editorId: auth()?.user?.id,
      // enterpriseId: fixedEnterprise?.id ? fixedEnterprise?.id : enterprise ? parseInt(enterprise) : null,
      contratDuration: parseInt(contractDuration),
      permitDate: date ? dayjs(new Date(date)).format('YYYY-MM-DD') : null,
      hasPermit: hasPermit == 'Oui' ? 'true' : 'false',
      occupationId: parseInt(occupation),
    };

    console.log('data to saved', data);
    if (selectedEmployer) {
      await postAxiosData(data);
    } else {
      setContract(data);
      handleClose();
    }
  };

  /** gestion des erreurs et succès */
  useEffect(() => {
    if (errorMassage?.data?.isGeoRestrictionFlagged) {
      setIsGeoRestrictionError(true);
    } else {
      setIsGeoRestrictionError(false);
    }
  }, [errorMassage]);
  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {
      get();
      handleReset();
      handleCloseInside();
      toast.success(
        `${
          successMessage?.message != null
            ? successMessage?.message
            : t(
                selectedContract
                  ? 'contract_modified_success_message'
                  : 'contract_added_success_message'
              )
        } `,
        {
          duration: 4000,
          // icon: "👏",
          className: 'bg-success text-white',
        }
      );
    }
  }, [successMessage]);

  useEffect(() => {
    setCanEdit(!loading);
  }, [loading]);

  useEffect(() => {
    const selectedContractP = selectedContract || contract;
    // console.log("🚀 ~ useEffect ~ contract:", contract)
    if (selectedContract) {
      setCanEdit(false);
      setValue('contratNumber', selectedContractP?.contratNumber || undefined);
      setValue('salary', selectedContractP?.salary || undefined);
      setValue('indTransport', selectedContractP?.indTransport || undefined);
      setValue('indLogement', selectedContractP?.indLogement || undefined);
      setValue('indResponsabilite', selectedContractP?.indResponsabilite || undefined);
      setValue('indRepresentation', selectedContractP?.indRepresentation || undefined);
      setValue('primeExploitation', selectedContractP?.primeExploitation || undefined);
      setValue('sursalaire', selectedContractP?.sursalaire || undefined);
      setValue('primeSalissure', selectedContractP?.primeSalissure || undefined);
      setValue('indCaisse', selectedContractP?.indCaisse || undefined);
      setValue('bonus', selectedContractP?.bonus || undefined);
      setValue('primePanier', selectedContractP?.primePanier || undefined);
      setValue('billetAvion', selectedContractP?.billetAvion || undefined);
      setValue('autresPrimes', selectedContractP?.autresPrimes || undefined);
      setValue('qualification', selectedContractP?.qualification || undefined);
      setValue('permitNumber', selectedContractP?.permitNumber || undefined);
      setContractDuration(selectedContractP?.contratDuration);
      setHasPermit(
        selectedContractP?.permitDate?.length > 0 ||
          selectedContractP?.permitDate?.length > 0 ||
          selectedContractP?.hasPermit == true
          ? 'Oui'
          : 'Non'
      );
      // setHasPermit(selectedContract?.hasPermit == true ? 'Oui' : 'Non')
      setDate(selectedContractP?.permitDate);
      setOccupation(selectedContractP?.occupation?.id || selectedContractP?.occupationId);
      setEnterprise(selectedContractP?.enterprise?.id);
    } else {
      setCanEdit(true);
      // alert("rien")
      handleReset();
    }
  }, [selectedContract, contract]);

  const handleCloseInside = () => {
    // Warn user if there are unsaved changes in update mode
    if (isUpdateMode && isDirty && canEdit) {
      const confirmClose = window.confirm(
        t('alerts.unsavedChanges') || 'You have unsaved changes. Are you sure you want to close?'
      );
      if (!confirmClose) return;
    }

    if (handleCloseOnly) {
      handleCloseOnly();
    } else {
      handleReset();
      handleClose();
      setCanEdit(true);
    }
  };

  const handleAddPoste = () => {
    occupationName &&
      window.confirm(t('add_position_confirm_message', { occupationName })) &&
      createOccupation({ name: occupationName, creatorId: auth()?.user?.id });
  };

  useEffect(() => {
    if (successMessageO?.status === 200 || successMessageO?.status === 201) {
      fetchDataO();
      toast.success(
        `${
          successMessageO?.message != null
            ? successMessageO?.message
            : t('position_added_success_message')
        } `,
        {
          duration: 4000,
          // icon: "👏",
          className: 'bg-success text-white',
        }
      );
    }
  }, [successMessageO]);

  // useEffect(() => {
  //   createdOccupation && setOccupation(createdOccupation?.data?.id)
  // }, [createdOccupation]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={'lg'}
      onClose={handleCloseInside}
      aria-labelledby="customized-dialog-title"
      open={open}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar className="bg-gray-50">
          <Typography sx={{ ml: 2, flex: 1 }} color={'green'} variant="h6" component="div">
            {isUpdateMode
              ? ` ${t(!canEdit ? 'contract_info_title' : 'edit_contract_title')} `
              : t('add_contract_title')}
            {selectedEmployer && (
              <strong className="text-center ms-2">
                {'<<' +
                  (selectedEmployer?.fullName ||
                    selectedEmployer?.firstName + ' ' + selectedEmployer?.lastName) +
                  '>>'}
              </strong>
            )}
            {isUpdateMode && (
              <>
                <Chip
                  label={
                    canEdit
                      ? t('general.editMode') || 'Edit Mode'
                      : t('general.viewMode') || 'View Mode'
                  }
                  size="small"
                  color={canEdit ? 'warning' : 'info'}
                  sx={{ ml: 2 }}
                />
                {selectedContract?.updatedAt && (
                  <Typography
                    component="span"
                    variant="caption"
                    sx={{ ml: 2, color: 'gray', display: 'block', fontSize: '0.75rem' }}
                  >
                    {t('general.lastUpdated') || 'Last updated'}:{' '}
                    {formatDateTime(selectedContract?.updatedAt)}
                  </Typography>
                )}
              </>
            )}
          </Typography>
          {/* <PrintButton
                // toPDF={toPDF} 
              /> */}
          <div className="flex justify-end gap-2 pr-10">
            {selectedContract && (
              <Tooltip
                hasArrow
                label={t(canEdit ? 'lock_tooltip' : 'edit_tooltip')}
                bg="red.200"
                color="black"
                placement="bottom"
              >
                {/* <button
                  className={`flex items-center  gap-2 rounded-md p-1 shadow bg-white`}
                  onClick={() => setCanEdit(!canEdit)}
                > */}
                <IconButton
                  edge="start"
                  color="primary"
                  onClick={() => setCanEdit(!canEdit)}
                  aria-label="close"
                >
                  {canEdit ? (
                    <BsBan className="text-red-500" />
                  ) : (
                    <BsPencilSquare className="text-green-500" />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </div>
          <CloseModalButton iconColor={'red'} handleClose={handleCloseInside} />
        </Toolbar>
      </AppBar>
      {loadingCt ? (
        <FormSkeleton />
      ) : errorCt && isUpdateMode ? (
        <DialogContent dividers>
          {isGeoRestrictionError ? (
            <GeoRestrictionAlert />
          ) : (
            <Alert status="error" className="mb-5 rounded-lg shadow">
              <AlertIcon />
              <AlertTitle>
                {t('alerts.failedToLoadContractDetails') ||
                  'Failed to load contract details. Please close and try again.'}
              </AlertTitle>
            </Alert>
          )}
          <div className="flex justify-center gap-4 mt-4">
            <MButton variant="danger" onClick={handleCloseInside}>
              {t('buttons.close') || 'Close'}
            </MButton>
            <MButton colorScheme="blue" onClick={() => fetchContractData()}>
              {t('buttons.retry') || 'Retry'}
            </MButton>
          </div>
        </DialogContent>
      ) : (
        <DialogContent dividers>
          {selectedContract &&
            selectedContract?.eworkStatus !== undefined &&
            selectedContract?.eworkStatus !== null && (
              <EworkDemandStatusAlert
                eworkStatus={selectedContract?.eworkStatus}
                className="mb-5 rounded-lg shadow"
              />
            )}
          {selectedContract && !checkIsValidContrat(selectedContract) ? (
            <Alert className="mb-5 rounded-lg shadow" status="error">
              <AlertIcon />
              <AlertTitle>
                {selectedContract?.permitNumber ? '' : t('permit_missing_number_message') + ' - '}
                {t(
                  checkIsValidPermitDate(selectedContract)
                    ? 'permit_expires_message'
                    : 'permit_expired_message',
                  {
                    date:
                      dayjs(getExpiredPermitDate(selectedContract?.permitDate)).format(
                        'DD-MM-YYYY'
                      ) || '--',
                  }
                )}
              </AlertTitle>
              (
              {selectedContract?.permitDate
                ? dayjs(getExpiredPermitDate(selectedContract?.permitDate)).locale('fr').fromNow()
                : '--'}
              )
            </Alert>
          ) : (
            selectedContract && (
              <Alert className="mb-5 rounded-lg shadow" status="success">
                <AlertIcon />
                <AlertTitle>
                  {t('permit_valid_until_message', {
                    date:
                      dayjs(getExpiredPermitDate(selectedContract?.permitDate)).format(
                        'DD-MM-YYYY'
                      ) || '--',
                  })}
                  (
                  {t('permit_expires_relative_message', {
                    relativeTime: selectedContract?.permitDate
                      ? dayjs(new Date())
                          .locale('fr')
                          .to(
                            dayjs(getExpiredPermitDate(selectedContract?.permitDate)).locale('fr')
                          )
                      : '--',
                  })}
                  )
                </AlertTitle>
                {/* <AlertDescription>Your Chakra experience may be degraded.</AlertDescription> */}
              </Alert>
            )
          )}
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            {errorMassage?.message && (
              <Error message={errorMassage?.message !== '' && errorMassage?.message} />
            )}
            <Paper className="p-3">
              <div>
                <div className="flex justify-between">
                  <h2 className="font-bold text-green-500">{t('contract_info_title')}</h2>
                  {/* <BsPl<h2 className="font-bold text-green-500">
                  Informations sur le contrat
                </h2>usCircleFill color="green" size={30} /> */}
                </div>
                <hr />
                <div className="my-4 grid gap-2 md:grid-cols-2">
                  {/* Select enterprises */}
                  <MuiAUtocomplete
                    disabled={!canEdit}
                    displayOnly={!canEdit}
                    value={occupation}
                    label={t('select_position_label')}
                    options={occupations?.data}
                    format={{ value: 'id', label: 'name' }}
                    // value={occupation}
                    // defaultFormat={true}
                    inputValue={occupationName}
                    onInputChange={(event, newInputValue) => {
                      setOccupationName(newInputValue);
                    }}
                    onChange={(e, item) => setOccupation(item.value)}
                    handleNoOption={
                      <MButton onClick={handleAddPoste}>{t('add_position_button')}</MButton>
                    }
                    wrapperClasses={'flex-1 filter-item anime slideRight'}
                    dataCy={'position-autocomplete'}
                  />
                  {/* <div>
                  <InputField
                    disabled={!canEdit}
                    register={register}
                    variant="auth"
                    extra="mb-3"
                    label="Numéro de contrat"
                    // required={true}
                    // placeholder="FFGJKE4545FS"
                    id="contratNumber"
                    name="contratNumber"
                    type="text"
                    error={
                      errors.contratNumber?.message !== ""
                        ? errors.contratNumber?.message
                        : ""
                    }
                  />
                </div> */}
                  {/* Select contract duration */}
                  <MuiSelect
                    disabled={!canEdit}
                    displayOnly={!canEdit}
                    label={t('select_contract_duration_label')}
                    // marginRight={5}
                    value={contractDuration}
                    options={durations?.map((d) => {
                      return { label: d, value: d };
                    })}
                    onChange={(event) => {
                      setContractDuration(event.target.value);
                    }}
                    dataCy="contract-duration-select"
                  />
                </div>
              </div>
              {/* infos sur le salaire */}
              <div>
                <div>
                  <h2 className="font-bold text-green-500">{t('salary_info_title')}</h2>
                  <hr />
                </div>
                <div className="my-4 grid gap-2 md:grid-cols-6">
                  {/* Select categories */}
                  <div>
                    <InputField
                      disabled={!canEdit}
                      displayOnly={!canEdit}
                      displayValue={selectedContract?.salary}
                      register={register}
                      variant="auth"
                      extra="mb-3"
                      label={t('base_salary_label')}
                      // required={true}
                      defaultValue={'0'}
                      // placeholder="100000000"
                      id="salary"
                      name="salary"
                      type="number"
                      error={errors.salary?.message !== '' ? errors.salary?.message : ''}
                      min="0"
                      dataCy="base-salary-input"
                    />
                  </div>
                  <div>
                    <InputField
                      min="0"
                      disabled={!canEdit}
                      displayOnly={!canEdit}
                      displayValue={selectedContract?.indTransport}
                      register={register}
                      variant="auth"
                      defaultValue={'0'}
                      extra="mb-3"
                      label={t('transport_allowance_label')}
                      required={true}
                      // placeholder="20000000"
                      id="indTransport"
                      name="indTransport"
                      type="number"
                      error={
                        errors.indTransport?.message !== '' ? errors.indTransport?.message : ''
                      }
                      dataCy="transport-allowance-input"
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="housing-allowance-input"
                      min="0"
                      disabled={!canEdit}
                      displayOnly={!canEdit}
                      displayValue={selectedContract?.indLogement}
                      register={register}
                      variant="auth"
                      defaultValue={'0'}
                      extra="mb-3"
                      label={t('housing_allowance_label')}
                      required={true}
                      // placeholder="20000000"
                      id="indLogement"
                      name="indLogement"
                      type="number"
                      error={errors.indLogement?.message !== '' ? errors.indLogement?.message : ''}
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="responsibility-bonus-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('responsibility_bonus_label')}
                      displayValue={selectedContract?.indResponsabilite}
                      // required={true}
                      // placeholder="1000000"
                      id="indResponsabilite"
                      name="indResponsabilite"
                      type="number"
                      error={
                        errors.indResponsabilite?.message !== ''
                          ? errors.indResponsabilite?.message
                          : ''
                      }
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="representation-bonus-input"
                      disabled={!canEdit}
                      register={register}
                      variant="auth"
                      defaultValue={'0'}
                      extra="mb-3"
                      label={t('representation_bonus_label')}
                      displayValue={selectedContract?.indRepresentation}
                      // required={true}
                      // placeholder="105545"
                      id="indRepresentation"
                      name="indRepresentation"
                      type="number"
                      error={
                        errors.indRepresentation?.message !== ''
                          ? errors.indRepresentation?.message
                          : ''
                      }
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="expatriation-bonus-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('expatriation_bonus_label')}
                      displayValue={selectedContract?.primeExploitation}
                      // required={true}
                      // placeholder="500000"
                      id="primeExploitation"
                      name="primeExploitation"
                      type="number"
                      error={
                        errors.primeExploitation?.message !== ''
                          ? errors.primeExploitation?.message
                          : ''
                      }
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="extra-salary-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('extra_salary_label')}
                      displayValue={selectedContract?.sursalaire}
                      // required={true}
                      // placeholder="125066"
                      id="sursalaire"
                      name="sursalaire"
                      type="number"
                      error={errors.sursalaire?.message !== '' ? errors.sursalaire?.message : ''}
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="dirt-bonus-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('dirt_bonus_label')}
                      displayValue={selectedContract?.primeSalissure}
                      // required={true}
                      // placeholder="125066"
                      id="primeSalissure"
                      name="primeSalissure"
                      type="number"
                      error={
                        errors.primeSalissure?.message !== '' ? errors.primeSalissure?.message : ''
                      }
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="cash-allowance-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('cash_allowance_label')}
                      displayValue={selectedContract?.indCaisse}
                      // required={true}
                      // placeholder="125066"
                      id="indCaisse"
                      name="indCaisse"
                      type="number"
                      error={errors.indCaisse?.message !== '' ? errors.indCaisse?.message : ''}
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="bonus-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('bonus_label')}
                      displayValue={selectedContract?.bonus}
                      // required={true}
                      // placeholder="125066"
                      id="bonus"
                      name="bonus"
                      type="number"
                      error={errors.bonus?.message !== '' ? errors.bonus?.message : ''}
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="basket-bonus-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('basket_bonus_label')}
                      displayValue={selectedContract?.primePanier}
                      // required={true}
                      // placeholder="125066"
                      id="primePanier"
                      name="primePanier"
                      type="number"
                      error={errors.primePanier?.message !== '' ? errors.primePanier?.message : ''}
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="flight-ticket-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('flight_ticket_label')}
                      displayValue={selectedContract?.billetAvion}
                      // required={true}
                      // placeholder="125066"
                      id="billetAvion"
                      name="billetAvion"
                      type="number"
                      error={errors.bonus?.message !== '' ? errors.bonus?.message : ''}
                    />
                  </div>
                  <div>
                    <InputField
                      dataCy="other-bonuses-input"
                      disabled={!canEdit}
                      register={register}
                      defaultValue={'0'}
                      variant="auth"
                      extra="mb-3"
                      label={t('other_bonuses_label')}
                      displayValue={selectedContract?.autresPrimes}
                      // required={true}
                      // placeholder="125066"
                      id="autresPrimes"
                      name="autresPrimes"
                      type="number"
                      error={
                        errors.autresPrimes?.message !== '' ? errors.autresPrimes?.message : ''
                      }
                    />
                  </div>
                </div>
                <div>
                  <div>
                    <h2 className="font-bold text-green-500">{t('work_permit_info_title')}</h2>
                    <hr />
                  </div>
                  <MuiSelect
                    disabled={!canEdit}
                    displayOnly={!canEdit}
                    label={t('has_work_permit_label')}
                    // marginRight={5}
                    value={hasPermit}
                    options={[
                      { label: t('has_permit_yes_option'), value: 'Oui' },
                      { label: t('has_permit_no_option'), value: 'Non' },
                    ]}
                    onChange={(event) => {
                      setHasPermit(event.target.value);
                    }}
                    dataCy="has-permit-select"
                  />
                  <div className="my-4 grid gap-2 md:grid-cols-2 anime slideUp">
                    {hasPermit == 'Oui' && (
                      <>
                        <div>
                          <InputField
                            disabled={!canEdit}
                            displayOnly={!canEdit}
                            displayValue={selectedContract?.permitNumber}
                            register={register}
                            variant="auth"
                            extra="mb-3"
                            label={t('permit_number_label')}
                            // required={true}
                            // placeholder="GJHJSDK65656JJJ"
                            id="permitNumber"
                            name="permitNumber"
                            type="text"
                            error={
                              errors.permitNumber?.message !== ''
                                ? errors.permitNumber?.message
                                : ''
                            }
                            dataCy="permit-number-input"
                          />
                        </div>
                        <MuiDatePicker
                          label={t('permit_signature_date_label')}
                          value={date}
                          disabled={!canEdit}
                          displayOnly={!canEdit}
                          displayValue={selectedContract?.permitDate}
                          fullWidth={true}
                          onChange={(newValue) => setDate(new Date(newValue)?.getTime())}
                          wrapperClasses={'flex-1 filter-item anime w-full slideLeft'}
                          dataCy="permit-date-picker"
                        />
                      </>
                    )}
                  </div>
                </div>
                <Divider />
                <div className="grid grid-cols-2">
                  <div>
                    <Typography variant="body1">
                      {t('evaluation_label')} {contract?.evaluationAmount}
                    </Typography>
                    <img
                      src={`${config.app.api_url}/files/${contract?.evaluationOnlineFileUrl}`}
                      alt={t('evaluation_label')}
                      width={200}
                    />
                  </div>
                  <div>
                    <Typography variant="body1">{contract?.takenBy}</Typography>
                    <img
                      src={`${config.app.api_url}/files/${contract?.takenSignatureOnlineUrl}`}
                      alt={t('signature_label')}
                      width={200}
                    />
                  </div>
                </div>
              </div>
            </Paper>
            {selectedContract && (
              <Badge>
                {t('collected_by_label', {
                  name: selectedContract?.creator
                    ? `${selectedContract?.creator?.firstName} ${selectedContract?.creator?.lastName}`
                    : '--',
                })}
              </Badge>
            )}
            {selectedContract && (
              <MuiCollapse
                title={t('modification_history_label', { count: modifications?.data?.length || 0 })}
                bgColor={'rgba(150,0,0,0.1)'}
              >
                <List>
                  {modifications?.data
                    ?.sort((a, b) => a?.editedAt < b?.editedAt)
                    ?.map((m) => (
                      <ListItem disablePadding divider>
                        <ListItemButton>
                          <ListItemText
                            primary={`${m?.editedBy?.firstName || ''} ${m?.editedBy?.lastName || ''} --${formatDateTime(m?.editedAt)}`}
                            secondary={m?.description}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                </List>
              </MuiCollapse>
            )}
            <div className="flex justify-between p-4">
              <div>
                <MButton
                  variant={'danger'}
                  onClick={(e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    handleCloseInside();
                    // get();
                  }}
                >
                  {t('close_button')}
                </MButton>
              </div>
              <div>
                {((selectedContract && canEdit) ||
                  selectedContract == null ||
                  selectedContract == undefined) && (
                  <MButton type="submit" colorScheme="green" isLoading={loading}>
                    {loading
                      ? isUpdateMode
                        ? t('buttons.updating') || 'Updating...'
                        : t('buttons.saving') || 'Saving...'
                      : isUpdateMode
                        ? t('save_changes_button')
                        : t('add_button')}
                  </MButton>
                )}
              </div>
            </div>
          </form>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default AddContract;
